/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { YearPeriod } from './YearPeriod';
import {
    YearPeriodFromJSON,
    YearPeriodFromJSONTyped,
    YearPeriodToJSON,
    YearPeriodToJSONTyped,
} from './YearPeriod';
import type { PubListConfigReplacements } from './PubListConfigReplacements';
import {
    PubListConfigReplacementsFromJSON,
    PubListConfigReplacementsFromJSONTyped,
    PubListConfigReplacementsToJSON,
    PubListConfigReplacementsToJSONTyped,
} from './PubListConfigReplacements';
import type { PublistConfigProjectOrganisation } from './PublistConfigProjectOrganisation';
import {
    PublistConfigProjectOrganisationFromJSON,
    PublistConfigProjectOrganisationFromJSONTyped,
    PublistConfigProjectOrganisationToJSON,
    PublistConfigProjectOrganisationToJSONTyped,
} from './PublistConfigProjectOrganisation';
import type { DatePeriod } from './DatePeriod';
import {
    DatePeriodFromJSON,
    DatePeriodFromJSONTyped,
    DatePeriodToJSON,
    DatePeriodToJSONTyped,
} from './DatePeriod';

/**
 * 
 * @export
 * @interface PubListConfig
 */
export interface PubListConfig  {
    /**
     * 
     * @type {PubListConfigListTypeEnum}
     * @memberof PubListConfig
     */
    listType?: PubListConfigListTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof PubListConfig
     */
    personIds?: Array<number>;
    /**
     * 
     * @type {PublistConfigProjectOrganisation}
     * @memberof PubListConfig
     */
    projectOrganisationConfig?: PublistConfigProjectOrganisation;
    /**
     * 
     * @type {Array<number>}
     * @memberof PubListConfig
     */
    filterIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PubListConfig
     */
    filterPersons?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PubListConfig
     */
    keyIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PubListConfig
     */
    useMainName?: boolean;
    /**
     * 
     * @type {Array<DatePeriod>}
     * @memberof PubListConfig
     */
    filterByCreationDate?: Array<DatePeriod>;
    /**
     * 
     * @type {Array<YearPeriod>}
     * @memberof PubListConfig
     */
    filterByYear?: Array<YearPeriod>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PubListConfig
     */
    filterByType?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PubListConfig
     */
    excludeByType?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PubListConfig
     */
    filterByPr?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PubListConfig
     */
    filterByLang?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PubListConfig
     */
    filterByRole?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PubListConfig
     */
    filterByRoleExcl?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PubListConfig
     */
    filterPersonByRole?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PubListConfig
     */
    groupByYear?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PubListConfig
     */
    groupByType?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PubListConfig
     */
    pubsort?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PubListConfig
     */
    toc?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PubListConfig
     */
    locale?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PubListConfig
     */
    linking?: Array<string>;
    /**
     * 
     * @type {Array<PubListConfigReplacements>}
     * @memberof PubListConfig
     */
    replacements?: Array<PubListConfigReplacements>;
    /**
     * 
     * @type {string}
     * @memberof PubListConfig
     */
    style?: string;
    /**
     * 
     * @type {string}
     * @memberof PubListConfig
     */
    name?: string;
}


/**
 * @export
 */
export const PubListConfigListTypeEnum = {
    ResearchData: 'RESEARCH_DATA',
    Publication: 'PUBLICATION',
    All: 'ALL'
} as const;
export type PubListConfigListTypeEnum = typeof PubListConfigListTypeEnum[keyof typeof PubListConfigListTypeEnum];


/**
 * Check if a given object implements the PubListConfig interface.
 */
export function instanceOfPubListConfig(value: object): value is PubListConfig {
    return true;
}

export function PubListConfigFromJSON(json: any): PubListConfig {
    return PubListConfigFromJSONTyped(json, false);
}

export function PubListConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PubListConfig {
    if (json == null) {
        return json;
    }
    return {
        
                  'listType': json['listType'] == null ? undefined : json['listType'],
              'personIds': json['personIds'] == null ? undefined : json['personIds'],
                  'projectOrganisationConfig': json['projectOrganisationConfig'] == null ? undefined : PublistConfigProjectOrganisationFromJSON(json['projectOrganisationConfig']),
              'filterIds': json['filterIds'] == null ? undefined : json['filterIds'],
              'filterPersons': json['filterPersons'] == null ? undefined : json['filterPersons'],
              'keyIds': json['keyIds'] == null ? undefined : json['keyIds'],
                  'useMainName': json['useMainName'] == null ? undefined : json['useMainName'],
              'filterByCreationDate': json['filterByCreationDate'] == null ? undefined : ((json['filterByCreationDate'] as Array<any>).map(DatePeriodFromJSON)),
              'filterByYear': json['filterByYear'] == null ? undefined : ((json['filterByYear'] as Array<any>).map(YearPeriodFromJSON)),
              'filterByType': json['filterByType'] == null ? undefined : json['filterByType'],
              'excludeByType': json['excludeByType'] == null ? undefined : json['excludeByType'],
                  'filterByPr': json['filterByPr'] == null ? undefined : json['filterByPr'],
              'filterByLang': json['filterByLang'] == null ? undefined : json['filterByLang'],
              'filterByRole': json['filterByRole'] == null ? undefined : json['filterByRole'],
              'filterByRoleExcl': json['filterByRoleExcl'] == null ? undefined : json['filterByRoleExcl'],
              'filterPersonByRole': json['filterPersonByRole'] == null ? undefined : json['filterPersonByRole'],
                  'groupByYear': json['groupByYear'] == null ? undefined : json['groupByYear'],
                  'groupByType': json['groupByType'] == null ? undefined : json['groupByType'],
                  'pubsort': json['pubsort'] == null ? undefined : json['pubsort'],
                  'toc': json['toc'] == null ? undefined : json['toc'],
                  'locale': json['locale'] == null ? undefined : json['locale'],
              'linking': json['linking'] == null ? undefined : json['linking'],
              'replacements': json['replacements'] == null ? undefined : ((json['replacements'] as Array<any>).map(PubListConfigReplacementsFromJSON)),
                  'style': json['style'] == null ? undefined : json['style'],
                  'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PubListConfigToJSON(json: any): PubListConfig {
    return PubListConfigToJSONTyped(json, false);
}

export function PubListConfigToJSONTyped(value?: PubListConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'listType': value['listType'],
        'personIds': value['personIds'] == null? value['personIds']: value['personIds'],
        'projectOrganisationConfig': PublistConfigProjectOrganisationToJSON(value['projectOrganisationConfig']),
        'filterIds': value['filterIds'] == null? value['filterIds']: value['filterIds'],
        'filterPersons': value['filterPersons'] == null? value['filterPersons']: value['filterPersons'],
        'keyIds': value['keyIds'] == null? value['keyIds']: value['keyIds'],
        'useMainName': value['useMainName'],
        'filterByCreationDate': value['filterByCreationDate'] == null? value['filterByCreationDate']: (value['filterByCreationDate'] as Array<any>).map(DatePeriodToJSON),
        'filterByYear': value['filterByYear'] == null? value['filterByYear']: (value['filterByYear'] as Array<any>).map(YearPeriodToJSON),
        'filterByType': value['filterByType'] == null? value['filterByType']: value['filterByType'],
        'excludeByType': value['excludeByType'] == null? value['excludeByType']: value['excludeByType'],
        'filterByPr': value['filterByPr'],
        'filterByLang': value['filterByLang'] == null? value['filterByLang']: value['filterByLang'],
        'filterByRole': value['filterByRole'] == null? value['filterByRole']: value['filterByRole'],
        'filterByRoleExcl': value['filterByRoleExcl'] == null? value['filterByRoleExcl']: value['filterByRoleExcl'],
        'filterPersonByRole': value['filterPersonByRole'] == null? value['filterPersonByRole']: value['filterPersonByRole'],
        'groupByYear': value['groupByYear'],
        'groupByType': value['groupByType'],
        'pubsort': value['pubsort'],
        'toc': value['toc'],
        'locale': value['locale'],
        'linking': value['linking'] == null? value['linking']: value['linking'],
        'replacements': value['replacements'] == null? value['replacements']: (value['replacements'] as Array<any>).map(PubListConfigReplacementsToJSON),
        'style': value['style'],
        'name': value['name'],
    };
}


